import { render, staticRenderFns } from "./TemporaryOrdersUpload.vue?vue&type=template&id=f92e7c6c&scoped=true&"
import script from "./TemporaryOrdersUpload.vue?vue&type=script&lang=ts&"
export * from "./TemporaryOrdersUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92e7c6c",
  null
  
)

export default component.exports